import React, { useState } from 'react';
import styles from './auth.module.css';
import { Link, useNavigate } from 'react-router-dom';
import PhoneInput from '@/shared/ui/PhoneInput';
import {login, restorePassword} from './api';
import { toast } from 'react-toastify';
import { getUserProfile } from "@/entities/user/api/userApi.js";
import {useUser} from "../../entities/user/model/UserContext.jsx";
import Modal from "@/shared/ui/Modal/index.js";

const AuthPage = () => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const [isRestore, setIsRestore] = useState(false);
    const [restoreEmail, setRestoreEmail] = useState('');

    const { setUser} = useUser();

    const URL = import.meta.env.VITE_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const res = await login({ phone, password });
            const data = res.data;
            localStorage.setItem('access_token', data.accessToken);
            localStorage.setItem('refresh_token', data.refreshToken);

            const profileResponse = await getUserProfile();
            setUser(profileResponse.data);

            navigate('/');
        } catch (err) {
            console.error(err);
            toast.error(err?.response?.data?.message || 'Ошибка авторизации');
        }finally {
            setIsSubmitting(false);
        }
    };

    const handleRestorePassword = () => {
        setIsRestore(prevState => !prevState);
    }
    const handleRestore = async () => {
        try {
            await restorePassword(restoreEmail)
            setIsRestore(false);
            toast.success("Ваш новый пароль ждёт на почте")
        }catch (error) {
            console.error(error);
            toast.error(error.response.data.message || "Ошибка восстановления пароля")
        }
    }

    return (
        <section className={`${styles.authSection} container-custom`}>
            <Link to="/">
                <img className={styles.logo} src="/images/logo%20new.svg" alt="Логотип ПОДЗЕМЕЛЬЕ" />
            </Link>

            <h1 className={`${styles.h1} par1`}>Вход</h1>

            <form className={styles.form} onSubmit={handleSubmit}>
                <PhoneInput value={phone} onChange={setPhone} />

                <input
                    type="password"
                    name="password"
                    className="input"
                    placeholder="Пароль"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <p className={"body mt-1"}>Забыли пароль? <span
                    className={`body-bold ${styles.linkToReg}`}
                    onClick={handleRestorePassword}
                >
                    Восстановить
                </span>
                </p>
                <button className="btn btn-red-filled w-100 mb-5" disabled={isSubmitting}>{isSubmitting ? "Загрузка..." : "Авторизоваться"}</button>



                <a href={`${URL}/oauth2/authorization/yandex`} className="btn btn-red-outline__green-text w-100 mb-4">
                    Войти через Яндекс
                </a>
                <p className={"body text-center mt-1"}>У вас нет аккаунта? <Link
                    to={"/registration"}
                    className={`body-bold ${styles.linkToReg}`}
                >
                        Зарегистрироваться
                    </Link>
                </p>
            </form>
            <Modal
                isOpen={isRestore}
                onClose={handleRestorePassword}
                onConfirm={handleRestore}
                title={`Восстановить пароль по почте`}
                textConfirm={`Отправить письмо`}
            >
                <input
                    type="email"
                    value={restoreEmail}
                    onChange={(e) => setRestoreEmail(e.target.value)}
                    className={`input`}
                    placeholder={`email`}
                />
            </Modal>
        </section>
    );
};

export default AuthPage;
